import { cn } from '@/common/utilities.ts'

const LoaderVariants = {
  size: {
    sm: 'w-1 h-1',
    md: 'w-2 h-2',
    lg: 'w-3 h-3',
  },
  color: {
    black: 'bg-black',
    dark_gray: 'bg-gray-600',
    gray: 'bg-gray-500',
    light_gray: 'bg-gray-400',
    primary: 'bg-primary',
    white: 'bg-white',
  },
}

export type EllipsesLoaderProps = {
  size: keyof typeof LoaderVariants.size
  color?: keyof typeof LoaderVariants.color
}

export const PulsingEllipsesLoader = ({
  size = 'md',
  color = 'primary',
}: EllipsesLoaderProps) => {
  return (
    <div className="flex gap-2">
      {Array(3)
        .fill(0)
        .map((_, index) => {
          return (
            <div
              className={cn(
                LoaderVariants.size[size],
                LoaderVariants.color[color],
                'rounded-full',
                index == 0 && 'animate-grow-n-shrink',
                index == 1 && `animate-grow-n-shrink animate-delay-1000`,
                index == 2 && `animate-grow-n-shrink animate-delay-2000`
              )}
              key={index}
            ></div>
          )
        })}
    </div>
  )
}
